var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%","width":"100%"}},[_vm._m(0),_c('dv-scroll-board',{staticStyle:{"width":"100%","height":"300px","padding":"1em","background":"none"},attrs:{"config":_vm.config}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"thetitle"},[_c('span',[_vm._v("当前预估排名")]),_c('span',[_vm._v("20")])])
}]

export { render, staticRenderFns }